<template>
  <el-row>
    <el-col :span="24">
      <div class>
        <div class="head">
          <el-form ref="form" :model="searchForm" inline class="form">
            <el-form-item>
              <el-input
                placeholder="请输入关键字搜索"
                prefix-icon="el-icon-search"
                clearable
                @keyup.enter.native="seachTitle" 
                v-model="searchForm.strTitle"
              >
                <template slot="append">
                  <el-button type="color" @click="seachTitle">搜一下</el-button>
                </template>
              </el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-button @click="seachTitle" type="color">搜一下</el-button>
            </el-form-item>-->
          </el-form>
          <div class="count">
            <div class="left_count">
              <p>国内：</p>
              <span>{{ cnCount }}</span>
              <p>&nbsp;家</p>
            </div>
            <span style="color: #fff; opacity: 0.2">|</span>
            <div class="right_count">
              <p>国外：</p>
              <span>{{ enCount }}</span>
              <p>&nbsp;家</p>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="choose_box">
            <div class="choose_unit">
              <span>平台类型：</span>
              <div class="center_box">
                <span
                  :class="[
                    'center_box_child',
                    searchForm.strType == item.code ? 'isActiv' : '',
                  ]"
                  @click="changeUnitA(item)"
                  v-for="(item, index) in unitArr"
                  :key="index"
                >{{ item.name }}</span>
              </div>
            </div>
            <div class="choose_unit" v-if="searchForm.strType == '4' ? false : true">
              <span>技术领域：</span>
              <span
                :class="[
                  'center_box_child',
                  searchForm.strTechFieldEnum == '' ? 'isActiv' : '',
                ]"
                @click="chooseAll()"
              >全部</span>
              <div :class="[openLine ? 'pack_up' : '', 'center_box']">
                <span
                  :class="[
                    'center_box_child',
                    searchForm.strTechFieldEnum == item.code ? 'isActiv' : '',
                  ]"
                  @click="changeTechA(item)"
                  v-for="(item, index) in techArr"
                  :key="index"
                >{{ item.name }}</span>
              </div>
              <span v-if="openLine" style="cursor: pointer; margin-left: auto;" @click="openMore">
                更多
                <i class="el-icon-arrow-down" />
              </span>
              <span v-else style="cursor: pointer; margin-left: auto;" @click="openMore">
                收起
                <i class="el-icon-arrow-up" />
              </span>
            </div>
            <div
              class="choose_unit"
              v-if="
                searchForm.strType == 1 ||
                searchForm.strType == 2 ||
                searchForm.strType == 3
              "
            >
              <span>备案年份：</span>
              <div class="center_box">
                <span
                  :class="[
                    'center_box_child',
                    searchForm.srtTime == item.value ? 'isActiv' : '',
                  ]"
                  @click="changeTime(item)"
                  v-for="(item, index) in timeArr"
                  :key="index"
                >{{ item.lable }}</span>
              </div>
            </div>
            <div
              class="choose_unit"
              v-if="
                searchForm.strType == 1 ||
                searchForm.strType == 2 ||
                searchForm.strType == 3
              "
            >
              <span>所在地：</span>
              <div class="sel_box">
                <el-select
                  v-model="searchForm.strProvinces"
                  placeholder="请选择省份"
                  @change="getCity()"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in provinceArr"
                    :key="index"
                    :label="item.Name"
                    :value="item.ProvinceID"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="searchForm.strCitys"
                  placeholder="请选择地区"
                  clearable
                  @change="chooseCity()"
                >
                  <el-option
                    v-for="(item, index) in cityArr"
                    :key="index"
                    :label="item.Name"
                    :value="item.CityId"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="choose_unit" v-else>
              <span>所在地：</span>
              <div class="sel_box">
                <el-select
                  v-model="searchForm.strCitys"
                  placeholder="请选择国家"
                  @change="chooseCountry()"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in countryArr"
                    :key="index"
                    :label="item.CNName"
                    :value="item.CNName"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="sort_count" ref="basicInformation">
            <div class="left">
              <span :class="sortA == null ? '' : 'sortActiv'" @click="recomSort(null)">平台推荐</span>
              <div class="left_sort" >
                <!-- <div @click="timeSort">
                  <span>发布时间</span>
                  <img src="../../../assets/library/排序 (1).png" alt="" />
                </div>-->
                <div @click="hotSort(1)">
                  <span :class="sortA == 1 ? '' : 'sortActiv'">热度</span>
                  <img :class="hotA ? 'fanzhuan' : ''" src="../../../assets/library/排序 (1).png" alt />
                </div>
              </div>
            </div>
          </div>
          <div v-if="cardData.length > 0">
            <div class="card_box" v-if="searchForm.strType !== '4'">
              <div
                class="card"
                v-for="(item, index) in cardData"
                :key="index"
                @click="goDetail(item)"
              >
                <img :src="item.Logo ? item.Logo : '../../../assets/img/shifan.png' " alt />
                <!-- ../../../assets/img/shifan.png -->
                <div class="card_text">
                  <p class="card_name">{{ item.UnitName }}</p>
                  <p class="card_add" v-if="item.Address">{{ item.Address }}</p>
                  <p class="card_add" v-else>&nbsp;</p>
                  <div class="card_pop_wrap" v-if="item.TechFieldEnum.length > 0">
                    <span
                      class="card_pop"
                      v-for="(v, i) in item.TechFieldEnum.slice(0, 3)"
                      :key="i"
                    >{{ v }}</span>
                    <span v-if="item.TechFieldEnum.length > 3" class="card_pop">...</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="card_box" v-if="searchForm.strType == '4'"> -->
            <div class="card_box" v-else>
              <div
                class="card"
                v-for="(item, index) in cardData"
                :key="index"
                @click="goDetail(item)"
              >
                <img :src="item.Logo" alt />
                <div class="card_text">
                  <p class="card_name">{{ item.CNTitle }}</p>
                  <p class="card_add" v-if="item.Address">{{ item.Address }}</p>
                  <p class="card_add" v-else>&nbsp;</p>
                  <div class="card_pop_wrap">
                    <span class="card_pop" v-for="(v, i) in item.TechFieldEnum" :key="i">{{ v }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Empty v-else />
          <!-- 分页 -->
          <Pagination
            :page-size.sync="searchForm.pageSize"
            :page.sync="searchForm.page"
            :total="total"
            @pagination="getCardData"
          />
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { getAction, postAction } from '@/api/api'
import Pagination from '../components/Pagination/index.vue'
import qs from 'qs'
import { organPool, pcapi } from '@/api/url'
// import { scrollTo } from "../../../assets/library/scroll-to"; // 滚动方法
import Empty from '../../../components/empty.vue'

export default {
  name: 'Organization',
  data() {
    return {
      sortA: null,
      hotA: false,
      cnCount: '',
      enCount: '',
      provinceArr: [],
      cityArr: [],
      techA: '1',
      openLine: true,
      total: 1,
      searchForm: {
        action: 'Get_OrganizationList',
        pageSize: 9,
        page: 1,
        strTitle: '',
        strTechFieldEnum: '',
        strType: '1',
        strProvinces: '',
        strCitys: '',
        strSort: '',
        srtTime: '',
      },
      unitArr: [
        { name: '河南省新型研发机构', code: '1' },
        { name: '河南省技术转移示范机构', code: '2' },
        { name: '河南省产业技术创新战略联盟', code: '3' },
        { name: '国际技术转移机构', code: '4' },
      ],
      techArr: [],
      timeArr: [
        {
          lable: '全部',
          value: '',
        },
        {
          lable: 2021,
          value: 2021,
        },
        {
          lable: 2020,
          value: 2020,
        },
        {
          lable: 2019,
          value: 2019,
        },
        {
          lable: 2018,
          value: 2018,
        },
        {
          lable: 2017,
          value: 2017,
        },
        {
          lable: 2016,
          value: 2016,
        },
      ],
      cardData: [],
      countryArr: [],
    }
  },
  props: {},
  components: {
    Pagination,
    Empty,
  },
  mounted() {
    //// console.log(this.searchForm);
    this.changeUnitA({ name: '河南省新型研发机构', code: '1' })
    this.getCardData()
    this.getStatisticsCount()
    // this.changeTime({ lable: 2021, value: 2021 });
    this.getProvince()
  },
  methods: {
    chooseCountry() {
      this.getCardData()
    },
    getCountry() {
      let data = {
        action: 'Get_Country',
      }
      postAction(organPool, qs.stringify(data)).then((res) => {
        this.countryArr = res
      })
    },
    goDetail(a) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false
          break
        }
      }
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        //// console.log(a);
        //// console.log(this.searchForm.strType);
        const { href } = this.$router.resolve({
          path: '/OrganizationDetail',
          query: {
            id: a.ID,
            type: this.searchForm.strType,
          },
        })
        window.open(href, '_blank')
        // scrollTo(450, 0);
      } else {
        this.$router.push({
          path:
            this.Urls+'/Mobile/index.html#/OrganPoolDetail?id=' +
            a.ID +
            '&strType=' +
            this.searchForm.strType,
        })
      }
    },
    recomSort(a) {
      this.searchForm.page = 1
      this.sortA = a
      this.hotA = false
      // if (this.searchForm.strSort == "") {
      //   this.searchForm.strSort = "a.ClickRank  DESC";
      //   //// console.log("平台升");
      // } else {
      //   if (this.searchForm.strSort == "a.ClickRank  DESC") {
      //     this.searchForm.strSort = "a.ClickRank  ASC";
      //     //// console.log("平台降");
      //   } else {
      //     this.searchForm.strSort = "a.ClickRank  DESC";
      //     //// console.log("平台升");
      //   }
      // }
      this.getCardData()
    },
    hotSort(a) {
      this.searchForm.page = 1
      this.sortA = a
      this.hotA = !this.hotA
      if (this.searchForm.strSort == '') {
        this.searchForm.strSort = 'a.ClickRank  DESC'
        //// console.log("热度升");
      } else {
        if (this.searchForm.strSort == 'a.ClickRank  DESC') {
          this.searchForm.strSort = 'a.ClickRank  ASC'
          //// console.log("热度降");
        } else {
          this.searchForm.strSort = 'a.ClickRank  DESC'
          //// console.log("热度升");
        }
      }
      this.getCardData()
    },
    // timeSort() {
    //   this.searchForm.page = 1;
    //   if (this.searchForm.strSort == "") {
    //     this.searchForm.strSort = "a.id DESC";
    //     //// console.log("时间升");
    //   } else {
    //     if (this.searchForm.strSort == "a.id DESC") {
    //       this.searchForm.strSort = "a.id ASC";
    //       //// console.log("时间降");
    //     } else {
    //       this.searchForm.strSort = "a.id DESC";
    //       //// console.log("时间升");
    //     }
    //   }
    //   this.getCardData();
    // },
    seachTitle() {
      this.searchForm.page = 1
      this.getCardData()
      this.$refs.basicInformation.scrollIntoView({
			behavior: "smooth",  // 平滑过渡
			block: "start"  	// 上边框与视窗顶部平齐。默认值
		});
    },
    getStatisticsCount() {
      postAction(organPool, qs.stringify({ action: 'Get_Count' })).then(
        (res) => {
          //// console.log(res);
          if (res) {
            this.cnCount = res[0].CN
            this.enCount = res[0].EN
          }
        }
      )
    },
    chooseCity() {
      this.getCardData()
    },
    chooseAll() {
      this.searchForm.strTechFieldEnum = ''
      this.getCardData()
    },
    changeTime(a) {
      //// console.log(a);
      this.searchForm.srtTime = a.value
      this.getCardData()
    },
    changeTechA(a) {
      //// console.log(a);
      this.searchForm.strTechFieldEnum = a.code
      this.getCardData()
    },
    changeUnitA(a) {
      //// console.log(a);
      this.searchForm.strType = a.code
      this.searchForm.page = 1
      this.searchForm.strTechFieldEnum = ''
      //// console.log(a.code);
      switch (a.code) {
        case '1':
          this.techArr = [
            {
              name: '软件',
              code: 'A',
            },
            {
              name: '信息服务',
              code: 'B',
            },
            {
              name: '集成电路及电子元器件',
              code: 'C',
            },
            {
              name: '网络与通信',
              code: 'D',
            },
            {
              name: '计算机设备与终端',
              code: 'E',
            },
            {
              name: '显示技术及产品',
              code: 'F',
            },
            {
              name: '生物医药',
              code: 'G',
            },
            {
              name: '生态与环境',
              code: 'H',
            },
            {
              name: '新能源',
              code: 'I',
            },
            {
              name: '新材料',
              code: 'J',
            },
            {
              name: '医疗器械',
              code: 'K',
            },
            {
              name: '医疗卫生',
              code: 'L',
            },
            {
              name: '农业',
              code: 'M',
            },
            {
              name: '先进制造与装备',
              code: 'N',
            },
            {
              name: '交通与城建',
              code: 'O',
            },
            {
              name: '其他',
              code: 'P',
            },
          ]
          this.searchForm.strProvinces = ''
          this.searchForm.strCitys = ''
          break
        case '2':
          this.techArr = [
            {
              name: '电子信息技术',
              code: '电子信息技术',
            },
            {
              name: '生物与新医药技术',
              code: '生物与新医药技术',
            },
            {
              name: '航空航天技术',
              code: '航空航天技术',
            },
            {
              name: '新材料技术',
              code: '新材料技术',
            },
            {
              name: '高技术服务业',
              code: '高技术服务业',
            },
            {
              name: '新能源与节能技术',
              code: '新能源与节能技术',
            },
            {
              name: '资源与环境技术',
              code: '资源与环境技术',
            },
            {
              name: '高新技术改造传统产业',
              code: '高新技术改造传统产业',
            },
            {
              name: '其它',
              code: '其它',
            },
          ]
          this.searchForm.strProvinces = ''
          this.searchForm.strCitys = ''
          break
        case '3':
          this.techArr = [
            {
              name: '工业',
              code: '工业',
            },
            {
              name: '农业',
              code: '农业',
            },
            {
              name: '社会发展',
              code: '社会发展',
            },
          ]
          this.searchForm.strProvinces = ''
          this.searchForm.strCitys = ''
          break
        case '4':
          this.searchForm.strProvinces = ''
          this.searchForm.strCitys = ''
          this.getCountry()
          break
        default:
      }
      this.getCardData()
    },
    getCardData() {
      postAction(organPool, qs.stringify(this.searchForm)).then((res) => {
        //// console.log(res, "机构库机构库机构库机构库机构库机构库");
        if (this.searchForm.strType !== '4') {
          res.data.map((item) => {
            if (item.TechFieldEnum !== '') {
              item.TechFieldEnum = item.TechFieldEnum.split(',')
            }
          })
        }
        this.cardData = res.data
        this.total = res.count
        // console.log('res.count',res.count)
        //// console.log(typeof this.total, this.total);
      })
    },
    getProvince() {
      let data = {
        action: 'Get_Province',
      }
      postAction(pcapi, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          this.provinceArr = res
        }
      })
    },
    getCity() {
      this.cityArr = []
      this.searchForm.strCitys = ''
      let data = {
        action: 'Get_City',
        ProvinceID: this.searchForm.strProvinces,
      }
      postAction(pcapi, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          this.cityArr = res
          // this.cardData=[]
          this.getCardData()
        }
      })
    },
    openMore() {
      this.openLine = !this.openLine
    },
  },
}
</script>

<style lang="scss" scoped>
.isActiv {
  height: 1.875rem;
  background: #2769dc;
  opacity: 1;
  color: #ffffff;
  border-radius: 0.3125rem;
  padding: 0 0.3125rem;
}
.head {
  width: 100%;
  height: 21.875rem;
  background-image: url('../../../assets/library/组 3826.png');
  background-size: 100% 21.875rem;
}
.form {
  width: 45rem;
  height: 4rem;
  margin: 0 auto;
  padding-top: 5.75rem;
  .el-input {
    width: 37.25rem;
    /deep/.el-input__inner {
      height: 4rem !important;
      padding-left: 3.5rem;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      opacity: 1;
    }
    /deep/ .el-input__prefix {
      left: 1.25rem;
      .el-input__icon {
        font-size: 1.25rem;
        height: 4.5rem;
      }
    }
    /deep/ .el-input-group__append {
      border: none;
    }
    .el-button--color {
      background: #2769dc;
      border: none;
      widows: 7.75rem;
      height: 4rem;
      border-radius: 0;
      ::v-deep span {
        font-size: 1.25rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 0rem;
        color: #ffffff;
        opacity: 1;
      }
    }
  }
}
::v-deep .el-form-item {
  margin-right: 0 !important;
}
/deep/ .btn-prev,
.btn-next {
  background-color: #fff !important;
}
.count {
  width: 23.5rem;
  height: 2.875rem;
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.1) 48%,
    rgba(255, 255, 255, 0) 100%
  );
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 1.875rem;
  align-items: center;
  .left_count {
    margin-right: 0.6875rem;
    display: flex;
    align-items: center;
    margin-left: 1rem;
    p {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      opacity: 1;
    }
    span {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #00ffff;
      opacity: 1;
    }
  }
  .right_count {
    display: flex;
    align-items: center;
    margin-left: 1rem;
    p {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      opacity: 1;
    }
    span {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #00ffff;
      opacity: 1;
    }
  }
}
.center {
  transform: translateY(-5.75rem);
  width: 87.5rem;
  margin: 0 auto;
}
.choose_box {
  width: 84.25rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  margin: 0 auto;
  padding: 1.875rem 1.625rem;
  .choose_unit {
    display: flex;
    justify-content: flex-start;
    /* margin: 0.9375rem; */
    margin-bottom: 1.25rem;
    align-items: baseline;
    > span {
      align-content: center;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      padding: 0.375rem 1.125rem;
      font-weight: bold;

      color: #4a4a4a;
    }
    .center_box_child {
      margin-left: 0.8125rem;
      word-break: keep-all;
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 1.875rem;
      opacity: 1;
      cursor: pointer;
      padding: 0.3125rem 1rem;
    }
    .isActiv {
      background: #2769dc;
      opacity: 1;
      color: #ffffff;
      border-radius: 0.3125rem;
    }
    /deep/ .el-input__inner {
      padding-right: 1.875rem;
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 0.25rem;
      border: 0.0625rem solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: 0.875rem;
      height: 2.5rem;
      line-height: 2.5rem;
      outline: 0;
      padding: 0 0.9375rem;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
      &::placeholder {
        font-size: 1rem;
        line-height: 100%;
      }
    }
    /deep/ .el-input__suffix {
      right: 0.3125rem;
      .el-input__icon {
        height: 100%;
        width: 1.5625rem;
        text-align: center;
        transition: all 0.3s;
        line-height: 2.5rem;
      }
    }
    .center_box {
      display: flex;
      flex-direction: row;
      max-width: 69.5rem;
      overflow: hidden;
      flex: 1;
      flex-wrap: wrap;
      .center_box_child {
        margin-left: 0.8125rem;
        word-break: keep-all;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 1.875rem;
        opacity: 1;
        cursor: pointer;
      }
      .isActiv {
        background: #2769dc;
        opacity: 1;
        color: #ffffff;
        border-radius: 0.3125rem;
      }
    }
    .pack_up {
      height: 2.5rem;
    }
    .sel_box {
      margin-left: 0.8125rem;
      .el-select {
        margin-left: 0.9375rem;
      }
    }
    /deep/ .el-input__inner {
      width: 10.4375rem;
      height: 2.1875rem;
      background: #ffffff;
      border: 0.0625rem solid #e1e1e1;
      opacity: 1;
      border-radius: 0.3125rem;
      .el-input__icon {
        height: 100% !important;
      }
    }
  }
}
.sort_count {
  display: flex;
  justify-content: space-between;
  height: 4.375rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  opacity: 1;
  margin-top: 1.875rem;
  align-items: center;
  padding: 0 1.625rem;
  .left {
    display: flex;
    .sortActiv {
      color: #999999;
    }
    span {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
      cursor: pointer;
    }
    .left_sort {
      display: flex;
      div {
        cursor: pointer;
        margin-left: 2.3125rem;
      }
      img {
        width: 0.5313rem;
        height: 0.75rem;
        margin-left: 0.5625rem;
      }
      .fanzhuan {
        transform: rotate(180deg);
      }
    }
  }
}
.card_box {
  display: flex;
  justify-content: space-between;
  margin-top: 1.875rem;
  flex-wrap: wrap;
  .card {
    &:hover {
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      // background-color: red;
      box-sizing: border-box;
      border: 1px solid #2769dc;
      cursor: pointer;
    }
    width: 27.6875rem;
    height: 24.5rem;
    background: #ffffff;
    opacity: 1;
    border-radius: 0rem;
    margin-bottom: 3.125rem;
    img {
      width: 100%;
      vertical-align: bottom;
    }
    .card_text {
      height: 9.5rem;
      text-align: left;
      margin: 1.4375rem 1.5rem;
      .card_name {
        width: 100%;
        text-align: left;
        font-size: 1.1875rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 1.6875rem;
        color: #0561d2;
        opacity: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .card_add {
        width: 100%;
        font-size: 0.875rem;
        text-align: left;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 1.75rem;
        color: #aaaaaa;
        opacity: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: 0.75rem;
      }
      .card_pop_wrap {
        margin-top: 1.25rem;
        .card_pop {
          background: rgba(102, 102, 102, 0.09);
          border-radius: 0.9375rem;
          font-size: 0.8125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          padding: 0.375rem 0.625rem;
          margin-top: 1.25rem;
          margin-right: 0.5rem;
        }
        .pop {
          background: #e0dfdf;
          border-radius: 50%;
          font-size: 0.8125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          padding: 0.375rem 0.625rem;
          margin-top: 1.25rem;
          margin-right: 0.5rem;
        }
      }
    }
  }
}
.card_box:after {
  content: '';
  width: 30%;
  height: 0rem;
  // visibility: hidden;
  // display: none;
  cursor: none !important;
}
</style>